export { default as Quotes } from './Quotes';

export * from './quote';
